import * as React from 'react';
import { Helper } from '../../../../Helper';
import { IComposerImage } from '../../../../interfaces/IComposerImage';
import { Environment } from '../../../../services/Environment';
import { IAIcon } from '../../../icon/Icon';
import * as styles from './Rotator.css';

export interface IProps {
  images: IComposerImage[];
  token: string;
  environment: "Development" | "Test" | "Production";
  tenant: string;
  editMode: boolean;
  isMobile: boolean;
  bordeRadius?: number;
  openImageViewer: (index: number) => void;
}

export interface IState {
  index: number;
  isHovering: boolean;
}

export class Rotator extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      index: 0,
      isHovering: false
    };
  }

  public componentDidMount(): void {
    setTimeout(() => {
      this.render();
    }, 0);
    // this.startTimer();
  }

  // private startTimer(): void {
  //   if (this.props.images.length > 0) {
  //     setInterval(() => {
  //       if (this.state.index < this.props.images.length - 1) {
  //         this.setState({ index: this.state.index + 1 });
  //       } else {
  //         this.setState({ index: 0 });
  //       }
  //     }, 5000);
  //   }
  // }

  public render(): JSX.Element {
    let width = 0;
    if (document.getElementById("IA_rotator")) {
      const rotator: any = document.getElementById("IA_rotator");
      width = rotator.clientWidth;
    }
    const slides = [];
    this.props.images.forEach((image: IComposerImage) => {
      slides.push(
        <div
          key={`slide_${image.name}`}
          className={styles.IA_slide}
          style={{
            width: width,
          }}
        >
          <div className={styles.IA_slideUploaderSpinner}>
            <IAIcon
              title="Spinner"
              size={20}
              color={"#999999"}
            />
          </div>
          <div
            className={styles.IA_slideImage}
            style={{
              borderRadius: this.props.bordeRadius ?? 0,
              width: width,
              backgroundImage: `url("${Helper.getImageFromApiWhenOutsideSharepoint(Environment.getEnvironmentForImageAPI(this.props.environment), this.props.tenant, this.props.token, image.url, image.modified, "Full")}")`
            }}
          />
        </div>
      );
    });
    return (
      <div
        className={styles.IA_rotator}
        id={"IA_rotator"}
        style={{
          height: this.props.isMobile ? (screen.width - 80) / 16 * 9 : 349
        }}
      >
        <div
          className={styles.IA_slideWrapper}
          style={{
            width: width * this.props.images.length,
            left: -width * this.state.index
          }}
        >
          {slides}
        </div>
        <div
          className={styles.IA_navigation}
          style={{
            opacity: (this.state.isHovering || this.props.isMobile) && this.props.images.length > 0 ? 1 : 0
          }}
          onMouseEnter={() => {
            this.setState({ isHovering: true });
          }}
          onMouseLeave={() => {
            this.setState({ isHovering: false });
          }}
        >
          <div
            className={styles.IA_previous}
            style={{
              opacity: this.state.index > 0 ? 1 : 0
            }}
            onClick={() => this.state.index > 0 ? this.setState({ index: this.state.index - 1 }) : {}}
          >
            <IAIcon url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Left/SVG/ic_fluent_chevron_left_48_regular.svg" size={25} color={"white"} onClick={() => { }} />
          </div>
          <div
            className={styles.IA_next}
            style={{
              opacity: this.props.images.length > this.state.index + 1 ? 1 : 0
            }}
            onClick={() => this.props.images.length > this.state.index + 1 ? this.setState({ index: this.state.index + 1 }) : {}}
          >
            <IAIcon url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Right/SVG/ic_fluent_chevron_right_48_regular.svg" size={25} color={"white"} onClick={() => { }} />
          </div>
          <div
            className={styles.IA_open}
            onClick={() => !this.props.editMode ? this.props.openImageViewer(this.state.index) : {}}
          />
        </div>
      </div>
    );
  }
}